export default "__VITE_PUBLIC_ASSET__2698888b__"